export const SET_PAYOUTS = 'SET_PAYOUTS';
